export default __webpack_public_path__ + "static/media/Floor3MintTowerBuildingMain.346b628a.svg";